export default __webpack_public_path__ + "img/orange-arrow-down.facd1145.svg";